
// import libs
import cookieBar from './libs/cookieBar';

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
import './components/ie-edge-detection.js';
import './components/menu.js';

import './components/showMore.js';

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
function throttle (callback, limit) {
  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(null, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  }
}

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// init
cookieBar.init({
  // settings
  // infoText: 'Soubory cookies nám pomáhají poskytovat, chránit a zlepšovat naše služby. Prohlížením tohoto webu s jejich používáním souhlasíte.',
  // buttonText: 'Rozumím',
  ipCheck: false,
});

$('.lazy').Lazy({
  // your configuration goes here
  scrollDirection: 'vertical',
  effect: 'fadeIn',
  effectTime: 150,
  visibleOnly: true,
  threshold: 500,
  bind: 'event',
  onError: function(element) {
      console.log('error loading ' + element.data('src'));
  }
});

// Animations

// ----------------------------------------
//  scroll to
function scrollTo(e) {
  e.preventDefault();

  var href = $.attr(this, 'href');
  if (typeof href === 'undefined') {
      href = $.attr(this, 'data-href');
  }
  href = href.replace('/', '');
  var offset = $.attr(this, 'data-offset');

  var $target = $(href);
  if ($target.length) {
      $('html,body').animate({
        scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 10)
      }, {
        duration: 500,
        easing: 'swing'
      });
  }
}
$('.scrollTo').on('click', scrollTo);

// ----------------------------------------

// scripts here
// homepage news carousel
$('.carousel--news').slick({
  // lazyLoad: 'ondemand',
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  // autoplay: false,
  // autoplaySpeed: 3000,
  arrows: false,
  dots: true,
  centerPadding: '25.5rem', // (1366 - 650) / 14 / 2 
  responsive: [
    {
      breakpoint: 992,
      settings: {
        // arrows: true,
        slidesToShow: 1,
        // slidesToScroll: 1,
        centerMode: false,
      }
    },
  ],
});

$('.carousel--projects').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
});

// $('.carousel--news .carousel__item').on('click', function(e) {
//   console.log($(this));
// });

// https://codepen.io/dimsemenov/pen/GAIkt
$('.gallery').each(function() {
  $(this).magnificPopup({
    delegate: 'a',
    gallery: {
      enabled: true
    },
    type: 'image',
    removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function() {
        // just a hack that adds mfp-anim class to markup
         this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
         this.st.mainClass = this.st.el.attr('data-effect');
      }
    },
    closeOnContentClick: true,
    midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
  });
});